import { camelizeKeys } from "humps";
import { SidePanelType, useSidePanel, useSidePanelActions } from "PFApp/stores/side_panels_store";
import { Profile, ProfilePreview } from "PFTypes";
import { ProfilePreview as ProfilePreviewType } from "PFTypes";
import { useCallback } from "react";

export const useProfilePreview = () => {
  const { open, close, setData } = useSidePanelActions<Partial<ProfilePreviewType>>(
    SidePanelType.ProfilePreview
  );

  const showPreview = useCallback(
    (payload: Pick<ProfilePreview, "id" | "profile" | "showBookingButtons">) => {
      const camelizedProfile = camelizeKeys(payload.profile); // TODO: [SP-3359] Remove "camelizeKeys" when Profile type is camelized
      if (camelizedProfile?.suspendedAt) {
        return;
      }
      open(payload, false, true);
    },
    [open]
  );

  const completePreview = useCallback(
    (profile: Profile) => setData((data) => ({ ...data, profile, ready: true })),
    [setData]
  );

  return { showPreview, hidePreview: close, completePreview };
};

export const useProfilePreviewData = () => useSidePanel<ProfilePreviewType>(SidePanelType.ProfilePreview);
